/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 我收藏的巡演项目
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<member.CollectTourDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/tours`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
